import { BackButton } from "./BackButton";

interface BackNavigationBarProps {
  /** Optional content to render on the right side (e.g. "Book Now" button) */
  rightContent?: React.ReactNode;
}

export function BackNavigationBar({ rightContent }: BackNavigationBarProps) {
  return (
    <div className="sticky top-0 z-40 bg-white border-b border-gray-200 shadow-sm">
      <div className="container mx-auto px-4 h-16 flex items-center justify-between">
        <BackButton />
        {rightContent}
      </div>
    </div>
  );
}
